import { useQuery } from '@tanstack/react-query';

import { useCheckVerificationsComplete } from 'hooks/useCheckVerificationsComplete';
import http from 'services/http';
import { checkIsLogin } from 'utils/auth';
import { EmptyObj, isEmptyObject } from 'utils/predicate';

export const BLOCK_ASSET_KEY: string[] = ['blockAsset'];

export type CheckBlockedAssetsResponseDto =
  | {
      createdBy: string;
      updatedBy: string;
      beforeStatus: 'PUBLISHED' | 'UNPUBLISHED' | 'BLOCKED';
      afterStatus: 'PUBLISHED' | 'UNPUBLISHED' | 'BLOCKED';
      userId: string;
      persona: {
        id: string;
      };
      universe: null;
      scene: null;
      deletedBy: null;
      comment: null;
      id: string;
      createdAt: string | null; // timestamp
      updatedAt: string | null; // timestamp
      deletedAt: string | null; // timestamp
    }
  | EmptyObj;

export const checkIsBlockedAssets = (response?: CheckBlockedAssetsResponseDto) => {
  if (!response) return false;
  // 빈 객체면 블락된 에셋이 아님
  if (isEmptyObject(response)) return false;
  // 'BLOCKED' 상태면 블락된 에셋임
  if (response.afterStatus === 'BLOCKED') return true;
  return false;
};

export async function getCheckIsBlockedAssets() {
  return http.get<CheckBlockedAssetsResponseDto>(
    `/my/chatbot-asset-status-history/block/check`,
    {},
    { useRedirectAndLogout: false, useLoading: false }
  );
}

export const useGetCheckIsBlockedAssets = () => {
  const isCustomLogin = checkIsLogin();
  const { isAllVerificationCompleted } = useCheckVerificationsComplete();

  return useQuery({
    queryKey: BLOCK_ASSET_KEY,
    queryFn: getCheckIsBlockedAssets,
    enabled: isCustomLogin && isAllVerificationCompleted,
    refetchOnWindowFocus: true, // 이메일 인증 후에 재호출되도록
    useErrorBoundary: false, // 에러 바운더리로 넘기지 않기 (엄청 중요한 API는 아님)
  });
};
